import type { SVGProps } from "react";
const SvgAiBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d_13614_22770)">
      <path
        d="M8 0H2C1.44772 0 1 0.447715 1 1V6.12434C1 6.68253 1.23328 7.21533 1.64344 7.59395L4.59597 10.3194C5.00279 10.6949 5.6373 10.6684 6.01141 10.2603L8.47431 7.57348C8.81243 7.20462 9 6.72242 9 6.22203V1C9 0.447715 8.55228 0 8 0Z"
        fill="url(#paint0_linear_13614_22770)"
      />
      <text x="50%" y="50%" textAnchor="middle" style={{ fontSize: "6px", fill: "white", fontWeight: "bold" }}>
        A
      </text>
    </g>
    <defs>
      <filter
        id="filter0_d_13614_22770"
        x="0"
        y="0"
        width="10"
        height="12.5846"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13614_22770" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13614_22770" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_13614_22770" x1="5" y1="0" x2="5" y2="11" gradientUnits="userSpaceOnUse">
        <stop stopColor="#783EC1" />
        <stop offset="0.4" stopColor="#783EC1" />
        <stop offset="1" stopColor="#4D287B" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAiBadge;
